import React, { useState, useEffect, useRef } from 'react';
import { motion, useMotionValue, useTransform, animate } from 'framer-motion';

/**
 * Animated number counter. `value` is the target value; the displayed number
 * tweens from the previous value over `duration` seconds.
 * `format` is a function that turns a numeric value into a display string.
 */
const AnimatedCounter = ({ value, duration = 0.9, format = (n) => n.toFixed(2) }) => {
  const motionValue = useMotionValue(0);
  const rounded = useTransform(motionValue, (latest) => format(latest));
  const [text, setText] = useState(format(value || 0));
  const previousRef = useRef(value || 0);

  useEffect(() => {
    const controls = animate(motionValue, value || 0, {
      duration,
      ease: [0.22, 0.7, 0.18, 1.0],
      onUpdate: () => setText(rounded.get()),
    });
    previousRef.current = value || 0;
    return () => controls.stop();
  }, [value, duration]);

  return <motion.span>{text}</motion.span>;
};

export default AnimatedCounter;
